"use client";
import "@/components/constants/template/style.css";
import { observer } from "mobx-react";
import styled from "styled-components";
import { useContext, useEffect, useRef } from "react";
import ProductBanner from "/public/assets/images/products/product-visual.png";
import ProductMoBanner from "/public/assets/images/products/product-visual-mo.png";
import { useStore } from "@/store";
import { useSearchParams } from "next/navigation";
import { SIZES } from "@/components/constants";
import { LayoutContext } from "@/app/ClientRootHomepage";
import { NoDataList } from "@/styles/CommonStyle";
import TabSwipeNextIcon from "/public/assets/icons/tab-swipre-next-ico.png";
import TabSwipePrevIcon from "/public/assets/icons/tab-swipre-prev-ico.png";
import {useMediaQuery} from "react-responsive";

const TemplateTypePage = observer(() => {
    const isTablet = useMediaQuery({
        query: `(max-width: ${SIZES.TABLET})`
    });
    const wrapRef = useRef(null);
    const { rootRef } = useContext(LayoutContext);
    const { contentStore, navigationStore } = useStore();
    const searchParams = useSearchParams();
    const menuId = searchParams.get("menu-id");
    useEffect(() => {
        if (!menuId) return;
        if (!wrapRef.current) return;
        contentStore.setMenuContent(navigationStore.navigateList, menuId, undefined).then(async () => {
                await import("@/components/constants/template/index.js");
                window.initTemplateUI(wrapRef.current, rootRef?.current);
            }).catch((e) => {
                console.error("template init error:", e);
            });
        return () => {
            contentStore.setTemplateClear();
        };
    }, [menuId, isTablet]);
    const handleClick = (e) => {
        const tabEl = e.target.closest(".tabs-item");
        if (!tabEl || !wrapRef.current?.contains(tabEl)) return;

        const root = wrapRef.current;
        const tabName = tabEl.getAttribute("data-template-module-tab");
        if (!tabName) return;

        root.querySelectorAll(".tabs-item").forEach((el) => el.classList.remove("active"));
        tabEl.classList.add("active");

        root
            .querySelectorAll(".module-section > .content-item")
            .forEach((c) => c.classList.remove("active"));

        const targetContent = root.querySelector(
            `.module-section > .content-item[data-template-module-content="${tabName}"]`
        );
        if (targetContent) targetContent.classList.add("active");
        window.initTemplateUI(wrapRef.current, rootRef?.current);
    };

    return (
        <TemplateTypeWrap>
            <div className="temp-sec">
                <div className="inner-bg-wrap">
                    {
                        !isTablet ? (
                        <img src={ProductBanner.src} alt="템플릿 페이지 배너" />
                    ) : (
                        <img src={ProductMoBanner.src} alt="템플릿 페이지 배너" />
                    )}
                </div>

                <div
                    className="template-wrap"
                    ref={wrapRef}
                    onClick={handleClick}
                >
                    {contentStore.templateTabHtml ? (
                        <>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: contentStore.templateTabHtml,
                                }}
                            />

                            <div
                                dangerouslySetInnerHTML={{
                                    __html: contentStore.templateContentHtml,
                                }}
                            />
                        </>
                    ) : (
                        <NoDataList>데이터가 없습니다.</NoDataList>
                    )}
                </div>
            </div>
        </TemplateTypeWrap>
    );
});


const TemplateTypeWrap = styled.div`
    padding-bottom: 150px;

    .tab-swiper .swiper-slide {
        width: auto !important;
    }

    .inner-bg {
        transition: height 0.4s ease;
    }

    .inner-bg-wrap {
        width: 100%;
        height: 300px;
        overflow: hidden;
        transition: height 0.3s ease;

        img {
            width: 100%;
            height: 300px;
            object-fit: cover;
        }
    }

    body.depth-fixed & .temp-sec .inner-bg-wrap {
        height: 0;
    }

    .template-wrap {
        padding: 0 100px;
        margin-top: 40px;
        
        b, strong{
            font-weight: bold;
        }
        
        a:not(.common-badge){
            text-decoration: underline;
        }
        
        .tab-swiper-nav-wrap{
            display: block;
            align-items: center;
            margin-bottom: 60px;
            gap: 10px;
            &.active{
                display: flex;    
            }
            .tab-swiper-prev,
            .tab-swiper-next {
                display: none;
                width: 24px;
                height: 24px;
                flex-shrink: 0;
                cursor: pointer;
                background-repeat: no-repeat;
                background-size: cover;
                background-position: center;
                &.active{
                    display: block;    
                }
            }

            .tab-swiper-prev{
                background-image: url(${TabSwipePrevIcon?.src});
            }
            .tab-swiper-next{
                background-image: url(${TabSwipeNextIcon?.src});
            }
            
            
            .control-tab-wrap {
                display: flex;
                align-items: center;
                .tabs-item {
                    height: 56px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 0 30px;
                    font-weight: 600;
                    font-size: 20px;
                    line-height: 26px;
                    letter-spacing: 0.02em;
                    color: #999999;
                    border-bottom: 1px solid #cccccc;
                    cursor: pointer;

                    &.active {
                        color: #246ff2;
                        border-bottom: 1px solid #246ff2;
                    }
                }
            }
        }

        

        .module-section {
            .content-item {
                display: none;

                &.active {
                    display: block;
                }
            }
        }
    }
    body.depth-fixed & .temp-sec .template-wrap{
        .tab-swiper-nav-wrap{
            padding-top: 40px;
        }
    }

    @media (max-width: ${SIZES.TABLET}) {
        .template-wrap {
            padding: 0;
            margin-top: 60px;
            .tab-swiper-nav-wrap{
                display: block;
                &.active{
                    display: block;
                }
                .tab-swiper-prev,
                .tab-swiper-next{
                    display: none;
                    &.active{
                        display: none;
                    }
                }
            }
        }

        .inner-bg-wrap {
            height: 180px;
            img{
                height: 180px;
            }
        }
        

        body.depth-fixed & .temp-sec .inner-bg-wrap {
            height: 0;
        }
        body.depth-fixed & .temp-sec .template-wrap{
            .tab-swiper-nav-wrap{
                padding-top: 25px;
            }
        }
    }
`;

export default TemplateTypePage;
